import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Products } from "@/components/site/Products";
import { Benefits } from "@/components/site/Benefits";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <HowItWorks />
      <Products />
      <Benefits />
      <Faq />
      <Contact />
    </main>
  );
}

export default App;
